import {FUIFormContext} from "./form-context";
import {Injectable} from "@angular/core";
import {FUIContextType} from "./form-context-type";

/**
 * Context for controls being used in an inline edit mode such as grid edit. These controls are typically more
 * compact. They may not include a label since typically a grid will include a column header.
 */
@Injectable()
export class FUIInlineFormContext extends FUIFormContext {
    constructor() {
        super(FUIContextType.INLINE, "Inline");
    }
}
